import {
  createMutationKeys,
  createQueryKeys,
  mergeQueryKeys,
} from '@lukemorales/query-key-factory'
import { RequestTypes } from '@core/react-query/features/registers/registers/register/items'
import { createQueryKeyString } from '@core/react-query/queryParams'
import { APIAxiosInstance } from '@core/utils/api-axios-instance'

const registerItemsQueryKeys = createQueryKeys('register-items', {
  itemsByRegisterId: ({
    registerId,
    filter,
    ...rest
  }: RequestTypes['getRegisterItems']) => ({
    queryKey: [registerId, rest, filter],
    queryFn: async ({ pageParam = 1 }) => {
      const queryString = createQueryKeyString({
        page: pageParam,
        ...rest,
        filter: JSON.stringify(filter),
      })

      const { data } = await APIAxiosInstance.get(
        `registers/${registerId}/items${queryString}`,
      )
      return data
    },
  }),
})

const registerItemMutationKeys = createMutationKeys('register-items', {
  downloadRegisterItems: {
    mutationKey: null,
    mutationFn: async ({
      registerId,
      ...rest
    }: RequestTypes['downloadRegisterItems']) => {
      const { data } = await APIAxiosInstance.post(
        `registers/${registerId}/items/download/csv`,
        {
          ...rest,
        },
      )
      return data
    },
  },
})

export const registerItemsKeys = mergeQueryKeys(
  registerItemsQueryKeys,
  registerItemMutationKeys,
)['register-items']
